<template>
    <div v-bind:class="[{'blurred': !bodyParts},'skeleton-container']">
        <div class="header">
            <span>Wybierz odcinek i kończynę, której dotyczy leczenie.</span>
            <div class="btn-container">
                <btn class="copy-visit-btn"
                  text="Skopiuj wizytę" 
                  @click="openCopyVisitDialog()"
                  v-if="copyVisits.length > 0"
                ></btn>
                <router-link :to="{ name: 'Visit', params: { visitId: surveyId }}"
                  v-if="touchedParts.length > 0"
                  style="align-self: center">
                    <btn text="Przejdź do wizyty" :disabled="touchedParts.length === 0"></btn>
                </router-link>
                <btn text="Przejdź do wizyty" :disabled="touchedParts.length === 0" v-if="touchedParts.length === 0"></btn>
            </div>
        </div>
        <mq-layout :mq="['md', 'lg', 'xl']" v-if="bodyParts">
        <div class="skeleton-container__model">
            <div class="spinner-container" v-if="imageLoaded === false">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>
            <div class="skeleton-container__model__images"
                 v-bind:class="{'blurred' : imageLoaded === false}">
                    <img v-bind:style="{opacity : hideMuscles}"

                     id="muscles" class="skeleton-container__model__muscles"
                     src="../../assets/muscles_bg.png">
                    <img v-bind:style="{opacity : 1-hideMuscles}"
                     class="skeleton-container__model__skeleton"
                     src="../../assets/skeleton_bg.png">
            <div class="skeleton-dots-container">
                <div v-for="(item,index) in bodyParts"
                            filepath="../../static/disableDot.svg"
                            v-bind:key="index"
                        v-bind:id="item.id"
                        v-bind:class="{
                        'head' : (item.name === 'Głowa'),
                        'upperLimb' : (item.name === 'Kończyna górna'),
                        'spine' : (item.name === 'Kręgosłup'),
                        'lowerLimb' : (item.name === 'Kończyna dolna')}">
                    <div v-for="(child, index) in item.children"
                        v-bind:key="index"
                        v-if="child.children.length === 0"
                        v-bind:class="[{
                          'cervicalSegment' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek szyjny')),
                          'chestSegment' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek piersiowy')),
                          'lumbarSegment' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek lędźwiowy')),
                          'skullSegment' : ((item.name === 'Głowa')&&(child.name ==='Czaszka')),
                          'jawSegment' : ((item.name === 'Głowa')&&(child.name ==='Szczęka'))
                        }, 'dotContainer']">
                        <simple-svg  filepath="../../static/disableDot.svg"
                          class="skeleton-pointer"
                          v-bind:key="index"
                          v-bind:id="child.id"
                          v-on:click.native = "checkPointerSpine(child.id, child.svgPathId)"
                          v-bind:class="[{
                            'active' : touchedParts.filter(pointerId => child.id === pointerId).length > 0,
                            'colored' : coloredParts.filter(pointerId => child.id === pointerId).length > 0,
                            'cervicalSegmentDot' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek szyjny')),
                            'chestSegmentDot' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek piersiowy')),
                            'lumbarSegmentDot' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek lędźwiowy')),
                            'skullSegmentDot' : ((item.name === 'Głowa')&&(child.name ==='Czaszka')),
                            'jawSegmentDot' : ((item.name === 'Głowa')&&(child.name ==='Szczęka'))
                          }, 'dot']"
                        ></simple-svg>
                    </div>
                    <div v-for="(child,index) in item.children"
                         v-if="child.children.length > 0"
                         v-bind:key="index"
                         v-bind:id="child.id"
                         v-bind:class="[{
                         'shoulder' : child.name === 'Bark',
                         'elbow' : child.name === 'Łokieć',
                         'wrist' : child.name === 'Nadgarstek',
                         'hand' : child.name === 'Ręka',
                         'hip' : child.name === 'Biodro',
                         'knee' : child.name === 'Kolano',
                         'ankle' : child.name === 'Staw skokowy',
                         'foot' : child.name === 'Stopa'},
                          'categories']">
                        <div v-for="(secondChild,index) in child.children"
                             v-bind:key="index"
                             v-bind:class="[{
                             'shoulderL': ((child.name === 'Bark')&&(secondChild.name === 'Lewy')),
                             'shoulderR': ((child.name === 'Bark')&&(secondChild.name === 'Prawy')),
                             'elbowL': ((child.name === 'Łokieć')&&(secondChild.name === 'Lewy')),
                             'elbowR': ((child.name === 'Łokieć')&&(secondChild.name === 'Prawy')),
                             'wristL': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Lewy')),
                             'wristR': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Prawy')),
                             'handL': ((child.name === 'Ręka')&&(secondChild.name === 'Lewa')),
                             'handR': ((child.name === 'Ręka')&&(secondChild.name === 'Prawa')),
                             'hipL': ((child.name === 'Biodro')&&(secondChild.name === 'Lewe')),
                             'hipR': ((child.name === 'Biodro')&&(secondChild.name === 'Prawe')),
                             'kneeL': ((child.name === 'Kolano')&&(secondChild.name === 'Lewe')),
                             'kneeR': ((child.name === 'Kolano')&&(secondChild.name === 'Prawe')),
                             'ankleL': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Lewy')),
                             'ankleR': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Prawy')),
                             'footL': ((child.name === 'Stopa')&&(secondChild.name === 'Lewa')),
                             'footR': ((child.name === 'Stopa')&&(secondChild.name === 'Prawa'))
                             }, 'dotContainer']">
                            <simple-svg filepath="../../static/disableDot.svg"
                                        v-bind:key="index"
                                        v-bind:id="secondChild.id"
                                        v-on:click.native = "checkPointerUpperLower(secondChild.id)"
                                        v-bind:class="[{
                                        'active' : touchedParts.filter(pointerId => secondChild.id === pointerId).length > 0,
                                        'colored' : coloredParts.filter(pointerId => secondChild.id === pointerId).length > 0,
                                        'shoulderLDot': ((child.name === 'Bark')&&(secondChild.name === 'Lewy')),
                                        'shoulderRDot': ((child.name === 'Bark')&&(secondChild.name === 'Prawy')),
                                        'elbowLDot': ((child.name === 'Łokieć')&&(secondChild.name === 'Lewy')),
                                        'elbowRDot': ((child.name === 'Łokieć')&&(secondChild.name === 'Prawy')),
                                        'wristLDot': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Lewy')),
                                        'wristRDot': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Prawy')),
                                        'handLDot': ((child.name === 'Ręka')&&(secondChild.name === 'Lewa')),
                                        'handRDot': ((child.name === 'Ręka')&&(secondChild.name === 'Prawa')),
                                        'hipLDot': ((child.name === 'Biodro')&&(secondChild.name === 'Lewe')),
                                        'hipRDot': ((child.name === 'Biodro')&&(secondChild.name === 'Prawe')),
                                        'kneeLDot': ((child.name === 'Kolano')&&(secondChild.name === 'Lewe')),
                                        'kneeRDot': ((child.name === 'Kolano')&&(secondChild.name === 'Prawe')),
                                        'ankleLDot': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Lewy')),
                                        'ankleRDot': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Prawy')),
                                        'footLDot': ((child.name === 'Stopa')&&(secondChild.name === 'Lewa')),
                                        'footRDot': ((child.name === 'Stopa')&&(secondChild.name === 'Prawa'))},'dot']">
                            </simple-svg>
                        </div>
                    </div>
                </div>
            </div>
            </div>
                <div class="skeleton-container__model__describe">
                <div class="position-relative full-height">
                    <div class="describe-section-1" v-bind:class="{
                    'hide' : touchedMainCategories.filter(id => id === bodyParts[0].id).length === 0,
                    'hideHeadMoveUp' : touchedMainCategories.filter(id => id === bodyParts[1].id).length > 0,
                    'activeHeadMoveUp' : touchedMainCategories.filter(id => id === bodyParts[0].id).length > 0}">
                        <div class="diagonal-container">
                            <div class="diagonal-container__diagonal"></div>
                        </div>
                        <div class="describe-container">
                            <span class="describe-container__title"
                                  @click="checkMainCategory(bodyParts[0].id)"
                                  v-bind:id="bodyParts[0].id">{{bodyParts[0].name}}</span>
                            <div class="describe-container__parts">
                                <div class="describe-container__parts__head">
                                    <md-checkbox v-for="(item,index) in bodyParts[0].children"
                                     v-bind:key="index"
                                     v-bind:id="item.id"
                                                 v-if="touchedMainCategories.filter(Id => bodyParts[0].id === Id).length > 0"
                                                 :value="item.id"
                                                 v-model="touchedParts"
                                                 v-on:change="checkCheckBox(item.id)"
                                                 v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => item.id === checkBoxId).length > 0,
                                                  'item.name' : true
                                                  },'md-primary']"
                                                 :disabled = "readOnlyMode">
                                    {{item.name}}
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="describe-section-2" v-bind:class="{
                    'hide' : touchedMainCategories.filter(id => id === bodyParts[1].id).length === 0,
                    'activeUpper' : touchedMainCategories.filter(id => id === bodyParts[1].id).length > 0,
                    'moveUp' : touchedMainCategories.filter(id => id === bodyParts[2].id).length > 0,
                    }">
                        <div class="diagonal-container">
                            <div class="diagonal-container__diagonal"></div>
                        </div>
                        <div class="describe-container">
                            <span class="describe-container__title"
                                  @click="checkMainCategory(bodyParts[1].id)"
                                  v-bind:id="bodyParts[1].id">{{bodyParts[1].name}}</span>
                            <div class="describe-container__parts">
                                <div v-for="(item,index) in bodyParts[1].children"
                                     v-if="touchedMainCategories.filter(Id => bodyParts[1].id === Id).length > 0"
                                     v-bind:key="index"
                                     v-bind:id="item.id"
                                     v-bind:class="item.name">
                                    <template v-if="item.children.length == 0">
                                      <md-checkbox 
                                        v-bind:id="item.id"
                                        :value="item.id"
                                        v-model="touchedParts"
                                        v-on:change="checkCheckBox(item.id)"
                                        v-bind:class="[{
                                        'elActive' : touchedParts.filter(checkBoxId => item.id === checkBoxId).length > 0
                                          },'md-primary']" 
                                        :disabled = "readOnlyMode"
                                      >
                                        {{item.name}}
                                      </md-checkbox>
                                    </template>
                                    <template v-else>
                                      <span @click="addCategoryCheckbox(item.id)"
                                        v-bind:class="{
                                        'elActive' :touchedCategories.filter(categoryId => item.id === categoryId).length > 0
                                        }">{{item.name}}</span>
                                      <md-checkbox v-for="(child,index) in item.children"
                                        v-if="touchedCategories.filter(parentId => item.id === parentId).length > 0"
                                        v-bind:key="index"
                                        v-bind:id="child.id"
                                        :value="child.id"
                                        v-model="touchedParts"
                                        v-on:change="checkCheckBox(child.id)"
                                        v-bind:class="[{
                                        'elActive' : touchedParts.filter(checkBoxId => child.id === checkBoxId).length > 0
                                          },'md-primary']" 
                                        :disabled = "readOnlyMode"
                                      >
                                        {{child.name}}
                                      </md-checkbox>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="describe-section-3" v-bind:class="{
                    'hide' : touchedMainCategories.filter(id => id === bodyParts[2].id).length === 0,
                    'hideSpineMoveDown' : touchedMainCategories.filter(id => id === bodyParts[1].id).length > 0,
                    'hideSpineMoveUp' : touchedMainCategories.filter(id => id === bodyParts[3].id).length > 0,
                    'activeSpineMoveUp' : touchedMainCategories.filter(id => id === bodyParts[2].id).length > 0}">
                        <div class="diagonal-container">
                            <div class="diagonal-container__diagonal"></div>
                        </div>
                        <div class="describe-container">
                            <span class="describe-container__title"
                                  @click="checkMainCategory(bodyParts[2].id)"
                                  v-bind:id="bodyParts[2].id">{{bodyParts[2].name}}</span>
                            <div class="describe-container__parts">
                                <div class="describe-container__parts__spine">
                                    <md-checkbox v-for="(item,index) in bodyParts[2].children"
                                     v-bind:key="index"
                                     v-bind:id="item.id"
                                                 v-if="touchedMainCategories.filter(Id => bodyParts[2].id === Id).length > 0"
                                                 :value="item.id"
                                                 v-model="touchedParts"
                                                 v-on:change="checkCheckBox(item.id)"
                                                 v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => item.id === checkBoxId).length > 0,
                                                  'item.name' : true
                                                  },'md-primary']"
                                                 :disabled = "readOnlyMode">
                                    {{item.name}}
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="describe-section-4" v-bind:class="{
                    'hide' : touchedMainCategories.filter(id => id === bodyParts[3].id).length === 0,
                     'activeLowerMoveUp' : touchedMainCategories.filter(id => id === bodyParts[3].id).length > 0
                     }">
                        <div class="diagonal-container">
                            <div class="diagonal-container__diagonal"></div>
                        </div>
                        <div class="describe-container">
                            <span class="describe-container__title" @click="checkMainCategory(bodyParts[3].id)" v-bind:id="bodyParts[3].id">{{bodyParts[3].name}}</span>
                            <div class="describe-container__parts">
                                <div v-for="(item,index) in bodyParts[3].children"
                                     v-bind:key="index"
                                     v-bind:id ="item.id"
                                     v-if="touchedMainCategories.filter(Id => bodyParts[3].id === Id).length > 0">
                                     <span @click="addCategoryCheckbox(item.id)"
                                           v-bind:class="{
                                           'elActive' :touchedCategories.filter(categoryId => item.id === categoryId).length > 0
                                           }">{{item.name}}</span>
                                     <md-checkbox v-for="(child,index) in item.children"
                                                 v-bind:key="index"
                                                 v-bind:id="child.id"
                                                 :value="child.id"
                                                  v-if="touchedCategories.filter(parentId => item.id === parentId).length > 0"
                                                 v-on:change="checkCheckBox(child.id)"
                                                 v-model="touchedParts"
                                                 v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => child.id === checkBoxId).length > 0
                                                 },'md-primary']" :disabled = "readOnlyMode">
                                        {{child.name}}
                                     </md-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="skeleton-view__container">
            <span class="skeleton-view__title">widok anatomii</span>
            <range-slider class="skeleton-view__slider"
                          min="0"
                          max="1"
                          step="0.01"
                          v-model="hideMuscles" >
            </range-slider>
            <div class="skeleton-view__slider-placeholder">
                <span class="skeleton-view__slider-placeholder__first">kości</span>
                <span class="skeleton_view__slider-placeholder__second">mięśnie</span>
            </div>
        </div>
        </mq-layout>
        <mq-layout :mq="['xs']">
            <div class=" mobile-skeleton">
                <div v-for="(item, index) in bodyParts"
                     v-bind:key="item.id"
                     class="mobile-skeleton__maincategory">
                    <div class="mobile-skeleton__maincategory__header" @click="checkMainCategoryMobile(item.id)">
                        <div class="mobile-skeleton__maincategory__header__leftside">
                            <span v-if="index === 0 && headCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{headCounter.length}}</span>
                            <span v-if="index === 1 && upperlimbCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{upperlimbCounter.length}}</span>
                            <span v-if="index === 2 && spineCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{spineCounter.length}}</span>
                            <span v-if="index === 3 && lowerlimbCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{lowerlimbCounter.length}}</span>
                            <span class="mobile-skeleton__maincategory__header__leftside__title"
                            >{{item.name}}</span>
                        </div>
                        <div :class="['mobile-arrow-' + index, 'mobile-arrow',{'rotate180' : touchedMainCategories.filter(element => element === item.id).length === 0}]"></div>
                    </div>
                    <div v-for="(child, childIndex) in item.children"
                         class=""class="mobile-skeleton__category"
                         v-if="(child.children.length > 0)&&(touchedMainCategories.filter(Id => item.id === Id).length > 0)"
                         v-bind:key="childIndex">
                        <span @click="addCategoryCheckbox(child.id)"
                              class="mobile-skeleton__category__name"
                        >{{child.name}}</span>
                        <md-checkbox v-for="(secondChild, secondIndex) in child.children"
                                     v-bind:key="secondIndex"
                                     v-bind:id="secondChild.id"
                                     :value="secondChild.id"
                                     v-if="(child.children.length > 0)&&(touchedMainCategories.filter(Id => item.id === Id).length > 0)"
                                     v-on:change="checkCheckBox(secondChild.id)"
                                     v-model="touchedParts"
                                     v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => secondChild.id === checkBoxId).length > 0
                                                 },'md-primary','mobile-skeleton__category__checkbox']" :disabled = "readOnlyMode">
                            {{secondChild.name}} {{child.name}}
                        </md-checkbox>
                    </div>
                        <md-checkbox v-for="(child, childIndex) in item.children"
                                     v-bind:key="childIndex"
                                     v-if="(child.children.length === 0)&&(touchedMainCategories.filter(Id => item.id === Id).length > 0)"
                                     :value="child.id"
                                     v-model="touchedParts"
                                     v-on:change="checkCheckBox(child.id)"
                                     v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => child.id === checkBoxId).length > 0,
                                                  'child.name' : true
                                                  },'md-primary','mobile-skeleton__category__checkbox',['spine-checkbox-' + childIndex]]"
                                     :disabled = "readOnlyMode">
                            {{child.name}}
                        </md-checkbox>
                </div>
            </div>
        </mq-layout>
        <mq-layout :mq="['sm']">
            <div class="mobile-skeleton">
                <div class="mobile-skeleton__model">
                    <div class="skeleton-container__model">
                        <div class="spinner-container" v-if="imageLoaded === false">
                            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
                        </div>
                        <div class="skeleton-container__model__images"
                             v-bind:class="{'blurred' : imageLoaded === false}">
                            <img v-bind:style="{opacity : hideMuscles}"

                                 id="muscles" class="skeleton-container__model__muscles"
                                 src="../../assets/muscles_bg.png">
                            <img v-bind:style="{opacity : 1-hideMuscles}"
                                 class="skeleton-container__model__skeleton"
                                 src="../../assets/skeleton_bg.png">
                            <div class="skeleton-dots-container">
                                <div v-for="(item,index) in bodyParts"
                                     filepath="../../static/disableDot.svg"
                                     v-bind:key="index"
                                     v-bind:id="item.id"
                                     v-bind:class="{
                        'head' : (item.name === 'Głowa'),
                        'upperLimb' : (item.name === 'Kończyna górna'),
                        'spine' : (item.name === 'Kręgosłup'),
                        'lowerLimb' : (item.name === 'Kończyna dolna')}">
                                    <div v-for="(child, index) in item.children"
                                         v-bind:key="index"
                                         v-if="child.children.length === 0"
                                         v-bind:class="[{
                         'cervicalSegment' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek szyjny')),
                         'chestSegment' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek piersiowy')),
                         'lumbarSegment' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek lędźwiowy')),
                         'skullSegment' : ((item.name === 'Głowa')&&(child.name ==='Czaszka')),
                         'jawSegment' : ((item.name === 'Głowa')&&(child.name ==='Szczęka'))}, 'dotContainer']">
                                        <simple-svg  filepath="../../static/disableDot.svg"
                                                     class="skeleton-pointer"
                                                     v-bind:key="index"
                                                     v-bind:id="child.id"
                                                     v-on:click.native = "checkPointerSpine(child.id, child.svgPathId)"
                                                     v-bind:class="[{
                                     'active' : touchedParts.filter(pointerId => child.id === pointerId).length > 0,
                                     'colored' : coloredParts.filter(pointerId => child.id === pointerId).length > 0,
                                     'cervicalSegmentDot' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek szyjny')),
                                     'chestSegmentDot' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek piersiowy')),
                                     'lumbarSegmentDot' : ((item.name === 'Kręgosłup')&&(child.name ==='Odcinek lędźwiowy')),
                                     'skullSegmentDot' : ((item.name === 'Głowa')&&(child.name ==='Czaszka')),
                                     'jawSegmentDot' : ((item.name === 'Głowa')&&(child.name ==='Szczęka'))
                                     }, 'dot']"

                                        ></simple-svg>
                                    </div>
                                    <div v-for="(child,index) in item.children"
                                         v-if="child.children.length > 0"
                                         v-bind:key="index"
                                         v-bind:id="child.id"
                                         v-bind:class="[{
                         'shoulder' : child.name === 'Bark',
                         'elbow' : child.name === 'Łokieć',
                         'wrist' : child.name === 'Nadgarstek',
                         'hand' : child.name === 'Ręka',
                         'hip' : child.name === 'Biodro',
                         'knee' : child.name === 'Kolano',
                         'ankle' : child.name === 'Staw skokowy',
                         'foot' : child.name === 'Stopa'},
                          'categories']">
                                        <div v-for="(secondChild,index) in child.children"
                                             v-bind:key="index"
                                             v-bind:class="[{
                             'shoulderL': ((child.name === 'Bark')&&(secondChild.name === 'Lewy')),
                             'shoulderR': ((child.name === 'Bark')&&(secondChild.name === 'Prawy')),
                             'elbowL': ((child.name === 'Łokieć')&&(secondChild.name === 'Lewy')),
                             'elbowR': ((child.name === 'Łokieć')&&(secondChild.name === 'Prawy')),
                             'wristL': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Lewy')),
                             'wristR': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Prawy')),
                             'handL': ((child.name === 'Ręka')&&(secondChild.name === 'Lewa')),
                             'handR': ((child.name === 'Ręka')&&(secondChild.name === 'Prawa')),
                             'hipL': ((child.name === 'Biodro')&&(secondChild.name === 'Lewe')),
                             'hipR': ((child.name === 'Biodro')&&(secondChild.name === 'Prawe')),
                             'kneeL': ((child.name === 'Kolano')&&(secondChild.name === 'Lewe')),
                             'kneeR': ((child.name === 'Kolano')&&(secondChild.name === 'Prawe')),
                             'ankleL': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Lewy')),
                             'ankleR': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Prawy')),
                             'footL': ((child.name === 'Stopa')&&(secondChild.name === 'Lewa')),
                             'footR': ((child.name === 'Stopa')&&(secondChild.name === 'Prawa'))
                             }, 'dotContainer']">
                                            <simple-svg filepath="../../static/disableDot.svg"
                                                        v-bind:key="index"
                                                        v-bind:id="secondChild.id"
                                                        v-on:click.native = "checkPointerUpperLower(secondChild.id)"
                                                        v-bind:class="[{
                                        'active' : touchedParts.filter(pointerId => secondChild.id === pointerId).length > 0,
                                        'colored' : coloredParts.filter(pointerId => secondChild.id === pointerId).length > 0,
                                        'shoulderLDot': ((child.name === 'Bark')&&(secondChild.name === 'Lewy')),
                                        'shoulderRDot': ((child.name === 'Bark')&&(secondChild.name === 'Prawy')),
                                        'elbowLDot': ((child.name === 'Łokieć')&&(secondChild.name === 'Lewy')),
                                        'elbowRDot': ((child.name === 'Łokieć')&&(secondChild.name === 'Prawy')),
                                        'wristLDot': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Lewy')),
                                        'wristRDot': ((child.name === 'Nadgarstek')&&(secondChild.name === 'Prawy')),
                                        'handLDot': ((child.name === 'Ręka')&&(secondChild.name === 'Lewa')),
                                        'handRDot': ((child.name === 'Ręka')&&(secondChild.name === 'Prawa')),
                                        'hipLDot': ((child.name === 'Biodro')&&(secondChild.name === 'Lewe')),
                                        'hipRDot': ((child.name === 'Biodro')&&(secondChild.name === 'Prawe')),
                                        'kneeLDot': ((child.name === 'Kolano')&&(secondChild.name === 'Lewe')),
                                        'kneeRDot': ((child.name === 'Kolano')&&(secondChild.name === 'Prawe')),
                                        'ankleLDot': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Lewy')),
                                        'ankleRDot': ((child.name === 'Staw skokowy')&&(secondChild.name === 'Prawy')),
                                        'footLDot': ((child.name === 'Stopa')&&(secondChild.name === 'Lewa')),
                                        'footRDot': ((child.name === 'Stopa')&&(secondChild.name === 'Prawa'))},'dot']">
                                            </simple-svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mobile-skeleton-view__container">
                        <span class="mobile-skeleton-view__title">widok anatomii</span>
                        <range-slider class="mobile-skeleton-view__slider"
                                      min="0"
                                      max="1"
                                      step="0.01"
                                      v-model="hideMuscles" >
                        </range-slider>
                        <div class="mobile-skeleton-view__slider-placeholder">
                            <span class="mobile-skeleton-view__slider-placeholder__first">kości</span>
                            <span class="mobile-skeleton_view__slider-placeholder__second">mięśnie</span>
                        </div>
                    </div>
                </div>
                <div class="mobile-skeleton__menu">
                <div v-for="(item, index) in bodyParts"
                     v-bind:key="item.id"
                     class="mobile-skeleton__maincategory">
                    <div class="mobile-skeleton__maincategory__header" @click="checkMainCategoryMobile(item.id)">
                        <div class="mobile-skeleton__maincategory__header__leftside">
                            <span v-if="index === 0 && headCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{headCounter.length}}</span>
                            <span v-if="index === 1 && upperlimbCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{upperlimbCounter.length}}</span>
                            <span v-if="index === 2 && spineCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{spineCounter.length}}</span>
                            <span v-if="index === 3 && lowerlimbCounter.length > 0" :class="['mobile-counter-' + index,'mobile-skeleton__maincategory__header__leftside__counter']">{{lowerlimbCounter.length}}</span>
                            <span class="mobile-skeleton__maincategory__header__leftside__title"
                            >{{item.name}}</span>
                        </div>
                        <div :class="['mobile-arrow-' + index, 'mobile-arrow',{'rotate180' : touchedMainCategories.filter(element => element === item.id).length === 0}]"></div>
                    </div>
                    <div v-for="(child, childIndex) in item.children"
                         class=""class="mobile-skeleton__category"
                         v-if="(child.children.length > 0)&&(touchedMainCategories.filter(Id => item.id === Id).length > 0)"
                         v-bind:key="childIndex">
                        <span @click="addCategoryCheckbox(child.id)"
                              class="mobile-skeleton__category__name"
                        >{{child.name}}</span>
                        <md-checkbox v-for="(secondChild, secondIndex) in child.children"
                                     v-bind:key="secondIndex"
                                     v-bind:id="secondChild.id"
                                     :value="secondChild.id"
                                     v-if="(child.children.length > 0)&&(touchedMainCategories.filter(Id => item.id === Id).length > 0)"
                                     v-on:change="checkCheckBox(secondChild.id)"
                                     v-model="touchedParts"
                                     v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => secondChild.id === checkBoxId).length > 0
                                                 },'md-primary','mobile-skeleton__category__checkbox']" :disabled = "readOnlyMode">
                            {{secondChild.name}} {{child.name}}
                        </md-checkbox>
                    </div>
                    <md-checkbox v-for="(child, childIndex) in item.children"
                                 v-bind:key="childIndex"
                                 v-if="(child.children.length === 0)&&(touchedMainCategories.filter(Id => item.id === Id).length > 0)"
                                 :value="child.id"
                                 v-model="touchedParts"
                                 v-on:change="checkCheckBox(child.id)"
                                 v-bind:class="[{
                                                 'elActive' : touchedParts.filter(checkBoxId => child.id === checkBoxId).length > 0,
                                                  'child.name' : true
                                                  },'md-primary','mobile-skeleton__category__checkbox',['spine-checkbox-' + childIndex]]"
                                 :disabled = "readOnlyMode">
                        {{child.name}}
                    </md-checkbox>
                </div>
                </div>
            </div>
        </mq-layout>
        <md-dialog :md-active.sync="showCopyVisitDialog" class="copy-visit-dialog" @md-closed="closeCopyVisitDialog()">
          <div class="copy-visit-dialog__header">
            <span class="copy-visit-dialog__title">Wybierz wizytę do skopiowania</span>
            <div @click="closeCopyVisitDialog()">
              <md-icon class="copy-visit-dialog__close-icon" :md-src="require('../../assets/ic_close.svg')"/>
            </div>
          </div>
          <div class="copy-visit-dialog__content">
            <div class="spinner-container" v-if="copyVisitLoader === true">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>
            <div class="md-scrollbar md-theme-default"
                v-bind:class="{'blurred' : copyVisitLoader === true}">
              <div class="copy-visit-dialog__content-info"><strong>Uwaga!</strong> Kopiowanie historii wizyty spowoduje nieodwracalne usunięcie danych w aktualnej wizycie.</div>
              <md-content class="copy-visit-dialog__content-visit md-layout md-alignment-center-center md-gutter"
                v-for="(item, index) in copyVisits"
                v-bind:key="index"
                v-if="surveyId != item.id">
                <div class="md-layout-item">
                  {{ getDatetime(item.booked_from) }} - {{ generateHeader(item.skeletonElements) }}
                </div>
                <div class="md-layout-item md-small-size-35 md-xsmall-size-100 md-size-25 text-center">
                  <btn class="btn-small" text="Skopiuj" @click="copyVisit(item.id)"></btn>
                </div>
              </md-content>
            </div>
          </div>
        </md-dialog>
    </div>
</template>
<script>

import moment from 'moment'
import store from '../../store';
import {
  POINTER_ADD, POINTER_DELETE, POINTER_GET, BODY_PART_DATA_GET, 
  VISIT_SURVEYS_GET, SET_READONLY_MODE,
} from '../../store/action-modulation.type';
import CustomerHistoryService from '../../services/customerHistory.service';
import BusinessService from '../../services/business.service';
import VisitService from '../../services/visit.service';

export default {
  name: 'Skeleton',
  data() {
    return {
      bodyParts: null,
      hideMuscles: '1',
      isActive: true,
      surveyId: this.$route.params.visitId,
      lowerLimbTouched: false,
      coloredParts: [],
      touchedParts: [],
      touchedCategories: [],
      touchedMainCategories: [],
      readOnlyMode: false,
      imageLoaded: false,
      headCounter: [],
      upperlimbCounter: [],
      spineCounter: [],
      lowerlimbCounter: [],
      showCopyVisitDialog: false,
      copyVisits: [],
      copyVisitLoader: false,
    };
  },
  methods: {

    checkCounters() {
      this.headCounter = [];
      this.upperlimbCounter = [];
      this.spineCounter = [];
      this.lowerlimbCounter = [];
      this.bodyParts[0].children.forEach((child) => {
        if (this.touchedParts.filter(item => child.id === item).length > 0) {
          this.headCounter.push(child.id);
        }
      });
      this.bodyParts[1].children.forEach((category) => {
        category.children.forEach((child) => {
          if (this.touchedParts.filter(item => child.id === item).length > 0) {
            this.upperlimbCounter.push(child.id);
          }
        });
      });
      this.bodyParts[2].children.forEach((child) => {
        if (this.touchedParts.filter(item => child.id === item).length > 0) {
          this.spineCounter.push(child.id);
        }
      });
      this.bodyParts[3].children.forEach((category) => {
        category.children.forEach((child) => {
          if (this.touchedParts.filter(item => child.id === item).length > 0) {
            this.lowerlimbCounter.push(child.id);
          }
        });
      });
    },
    onLoaded() {
      const time = setInterval((() => {
        const image = document.getElementById('muscles');
        if (image) {
          if (image.complete) {
            this.imageLoaded = true;
            if (this.imageLoaded === true) {
              clearInterval(time);
            }
          }
        }
      }), 100);
    },

    checkMainCategory(mainCategoryId) {
      if (this.touchedMainCategories.filter(element => element === mainCategoryId).length === 0) {
        this.coloredParts = [];
        if (mainCategoryId === this.bodyParts[2].id) {
          this.hideMuscles = '0';
        }
        this.touchedMainCategories = [];
        this.touchedCategories = [];
        this.touchedMainCategories.push(mainCategoryId);
      } else {
        this.coloredParts = [];
        this.touchedMainCategories.forEach((element, index) => {
          if (element === mainCategoryId) {
            this.touchedMainCategories.splice(index, 1);
          }
        });
      }
    },

    checkMainCategoryMobile(mainCategoryId) {
      if (this.touchedMainCategories.filter(element => element === mainCategoryId).length === 0) {
        this.coloredParts = [];
        if (mainCategoryId === this.bodyParts[2].id) {
          this.hideMuscles = '0';
        }
        this.touchedCategories = [];
        this.touchedMainCategories.push(mainCategoryId);
      } else {
        this.coloredParts = [];
        this.touchedMainCategories.forEach((element, index) => {
          if (element === mainCategoryId) {
            this.touchedMainCategories.splice(index, 1);
          }
        });
      }
    },

    addCategoryCheckbox(categoryId) {
      this.coloredParts = [];
      if (this.touchedCategories.filter(data => categoryId === data).length === 0) {
        this.touchedCategories = [];
        this.touchedCategories.push(categoryId);
      } else {
        this.touchedCategories.forEach((element, index) => {
          if (element === categoryId) {
            this.touchedCategories.splice(index, 1);
          }
        });
      }
      this.bodyParts.forEach((item) => {
        item.children.forEach((child) => {
          if (child.id === categoryId) {
            child.children.forEach((secondChild) => {
              this.coloredParts.push(secondChild.id);
            });
          }
        });
      });
    },

    fetchBodyParts() {
      store.dispatch(BODY_PART_DATA_GET).then((data) => {
        let parts = data.data;
        parts.splice(0, 0, parts.splice(3, 1)[0]);
        store.commit(BODY_PART_DATA_GET, parts);
      });
    },

    checkPointerUpperLower(pointerId) {
      if (store.state.visit.readonlyMode === false) {
        if (this.touchedParts.filter(checkBoxId => pointerId === checkBoxId).length > 0) {
          this.bodyParts.forEach((item) => {
            item.children.forEach((child) => {
              child.children.forEach((secondChild) => {
                if (secondChild.id === pointerId) {
                  this.touchedMainCategories = [];
                  this.touchedCategories = [];
                  this.coloredParts = [];
                  this.touchedMainCategories.push(item.id);
                  this.touchedCategories.push(child.id);
                  child.children.forEach((coloredPart) => {
                    this.coloredParts.push(coloredPart.id);
                  });
                }
              });
            });
          });
          this.touchedParts.forEach((element, index) => {
            if (element === pointerId) {
              this.touchedParts.splice(index, 1);
              const elToDel = {
                visitId: this.surveyId,
                partToDel: pointerId,
              };
              store.dispatch(POINTER_DELETE, elToDel);
            }
          });
        } else {
          const elToAdd = {
            visitId: this.surveyId,
            partToAdd: pointerId,
          };
          this.bodyParts.forEach((item) => {
            item.children.forEach((child) => {
              child.children.forEach((secondChild) => {
                if (secondChild.id === pointerId) {
                  this.touchedMainCategories = [];
                  this.touchedCategories = [];
                  this.coloredParts = [];
                  this.touchedMainCategories.push(item.id);
                  this.touchedCategories.push(child.id);
                  child.children.forEach((coloredPart) => {
                    this.coloredParts.push(coloredPart.id);
                  });
                }
              });
            });
          });
          this.touchedParts.push(pointerId);
          store.dispatch(POINTER_ADD, elToAdd);
        }
        store.commit(POINTER_ADD, this.touchedParts);
      }
    },

    checkPointerSpine(pointerId, svgPathId) {
      if (store.state.visit.readonlyMode === false) {
        if (svgPathId != 21 && svgPathId != 22)  this.hideMuscles = '0';
        if (this.touchedParts.filter(checkBoxId => pointerId === checkBoxId).length > 0) {
          this.bodyParts[2].children.forEach((item) => {
            if (item.id === pointerId) {
              this.touchedMainCategories = [];
              this.touchedCategories = [];
              this.coloredParts = [];
              this.touchedMainCategories.push(this.bodyParts[2].id);
            }
          });
          this.touchedParts.forEach((element, index) => {
            if (element === pointerId) {
              this.touchedParts.splice(index, 1);
              const elToDel = {
                visitId: this.surveyId,
                partToDel: pointerId,
              };
              store.dispatch(POINTER_DELETE, elToDel);
            }
          });
        } else {
          this.bodyParts[2].children.forEach((item) => {
            if (item.id === pointerId) {
              this.touchedMainCategories = [];
              this.touchedCategories = [];
              this.coloredParts = [];
              this.touchedMainCategories.push(this.bodyParts[2].id);
            }
          });
          const elToAdd = {
            visitId: this.surveyId,
            partToAdd: pointerId,
          };
          this.touchedParts.push(pointerId);
          store.dispatch(POINTER_ADD, elToAdd);
        }
        if ([21,22].includes(svgPathId)) { 
          this.touchedMainCategories = []
          this.touchedMainCategories.push(this.bodyParts[0].id)
        };
        store.commit(POINTER_ADD, this.touchedParts);
      }
    },

    checkCheckBox(pointerId) {
      if (store.state.visit.readonlyMode === false) {
        if (this.touchedParts.filter(checkBoxId => pointerId === checkBoxId).length > 0) {
          this.touchedParts.forEach((element) => {
            if (element === pointerId) {
              const elToAdd = {
                visitId: this.surveyId,
                partToAdd: pointerId,
              };
              store.dispatch(POINTER_ADD, elToAdd);
            }
          });
        } else {
          const elToDel = {
            visitId: this.surveyId,
            partToDel: pointerId,
          };
          store.dispatch(POINTER_DELETE, elToDel);
        }
        store.commit(POINTER_ADD, this.touchedParts);
      }
    },

		getDatetime(date) {
			return moment(date).format("DD.MM.YYYY HH:mm");
		},

    fetchPointers() {
      this.touchedParts = [];
      store.dispatch(POINTER_GET, this.surveyId).then((data) => {
        data.data.forEach((element) => {
          this.touchedParts.push(element.id);
        });
      });
      store.commit(POINTER_ADD, this.touchedParts);
    },

    getCustomerVisits () {
      let businessId = BusinessService.getBusinessId();
      let customerId = this.$route.query.customer_id;

      if (businessId && customerId) {
        CustomerHistoryService.getCustomerHistory(businessId, customerId)
        .then(({ data }) => {
          this.copyVisits = data.booking;
        });
      }
    },

    closeCopyVisitDialog () {
      this.showCopyVisitDialog = false;
    },

    openCopyVisitDialog () {
      this.showCopyVisitDialog = true;
    },

    generateHeader(skeletonElements) {
			let result ='';
			this.bodyParts.forEach((item) => {
				item.children.forEach((child)=>{
					if (skeletonElements.filter(element => element.id === child.id).length > 0 ) {
						result += `${child.name} ${item.name}, `;
					}
					child.children.forEach((secondChild)=>{
						if (skeletonElements.filter(element => element.id === secondChild.id).length > 0 ) {
							result += `${secondChild.name} ${child.name}, `;
						}
					})
				})
			});
			result = result.slice(0,-2);
			return result;
    },

    copyVisit (fromVisitId) {
      this.copyVisitLoader = true;
      VisitService.copyVisit(this.surveyId, fromVisitId).then(resp => {
        this.fetchPointers();
        this.closeCopyVisitDialog();
        this.copyVisitLoader = false;
      });
    },

  },

  computed: {
    getState() {
      return store.state.skeleton;
    },
  },

  watch: {
    getState: {
      handler(state) {
        if (state.partsData !== null) {
          this.bodyParts = state.partsData;
          this.checkCounters();
        }
      },
      deep: true,
    },
  },

  created() {
    this.getCustomerVisits();
    this.fetchBodyParts();
    this.onLoaded();
    this.fetchPointers();
    store.dispatch(VISIT_SURVEYS_GET, this.surveyId).then(() => {
      let readonlyMode = store.state.visit.closedVisit;
      if (store.state.access.accessLevel == "owner" && readonlyMode) readonlyMode = false;
      store.dispatch(SET_READONLY_MODE, readonlyMode);
      this.readOnlyMode = readonlyMode;
    });
  },
};
</script>

<style src="./Skeleton.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Skeleton/Skeleton.vue